import { ConvertedWeightInput } from './converted-weight-input';
import style from './style.module.less';
import WeightLabel from '../../fulfillment-planner/weight/label';

import type { Weight } from '../../prop-types/weight-types';
import type { WeightUnit } from '../../prop-types/weight-unit';
import type React from 'react';

type BulkConvertedWeightFieldProps = {
  weight?: Weight;
  onChange: (weightValue: number, weightUnit: WeightUnit) => void;
  renderScale?: () => React.ReactNode;
};

export const BulkConvertedWeightField: React.FC<BulkConvertedWeightFieldProps> = ({ weight = {}, onChange, renderScale }) => {
  return (
    <div className={style['drawer-bulk-set-weight']}>
      <div className={style['weight-input-label']}>
        <WeightLabel />
      </div>
      <div className={style.weight}>
        <ConvertedWeightInput inputClassName={style['weight-input']} onChange={onChange} weight={weight} />
        {renderScale ? renderScale() : null}
      </div>
    </div>
  );
};
